module.exports = __webpack_public_path__ + "img/bottom.7645b350.png";